/**
 * 新版问卷调查路由
 */
// 问卷引导页
const QuestionGuide = (resolve) => {
  require.ensure(
    [],
    () => {
      resolve(require('@/views/question/guide.vue'));
    },
    'guide',
  );
};

// 问卷答题
const QuestionMain = (resolve) => {
  require.ensure(
    [],
    () => {
      resolve(require('@/views/question/main-page.vue'));
    },
    'subject',
  );
};

// 答题结果页
const QuestionResult = (resolve) => {
  require.ensure(
    [],
    () => {
      resolve(require('@/views/question/result.vue'));
    },
    'result',
  );
};

// 答题结果页
const QuestionPreview = (resolve) => {
  require.ensure(
    [],
    () => {
      resolve(require('@/views/question/preview.vue'));
    },
    'preview',
  );
};

// 前端路由
export default [
  {
    path: '/question/guide',
    name: 'question/guide',
    component: QuestionGuide,
    meta: { title: '问卷调查' },
  },
  {
    path: '/question/subject',
    name: 'question/subject',
    component: QuestionMain,
    meta: { title: '问卷调查' },
  },
  {
    path: '/question/result',
    name: 'question/result',
    component: QuestionResult,
    meta: { title: '问卷调查' },
  },
  {
    path: '/question/preview',
    name: 'question/preview',
    component: QuestionPreview,
    meta: { title: '问卷预览' },
  },
];
